module.exports = __webpack_public_path__ + "assets/static/media/logo-opus.782956e8.png";